export const ACTION_BUTTONS = {
  EDIT: "edit",
  EDITCOMPLETE: "editComplete",
  EMAIL: "email",
  WHATSAPP: "whatsApp",
  PHONECALL: "phoneCall",
  FOLLOWUP: "followUp",
  NEWTASK: "newTask",
  DELETE: "delete",
  CANCEL: "cancel",
  DOWNLOAD: "download",
  DESVINCULATE: "desvinculate",
  VIEWPROFILE: "viewProfile",
  VIEWDOCUMENTS: "viewDocuments",
  VINCULATE: "vinculate",
  SENDBYEMAIL: "sendByEmail",
  VIEWDETAIL: "viewDetail",
  REOPEN: "reopen",
  EDIFIN: "editfinished",
  CLONAR: "clonar",
  CLOSE: "close",
  SHAREWITH: "shareWith",
  SAVE: "save",
  PAYMENT: "payment",
  GENERATERAV: "generateRav",
  ADDNEWNESS: "addNewness",
  SECURITY: "security"
};

export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const USER = "user";
export const EMAIL = "email";
export const USERID = "userId";
export const DISPLAYNAME = "displayName";
export const USERNAME = "userName";
export const TOKEN_NOTIFICATION = "notificationToken";
export const ROLE = "role";

export const LANGUAGES = ["ESP", "ENG", "POR"];

export const KEY_GOOGLE_MAPS = "AIzaSyC8gOTtSE1DWjUY9DCM1f3JMcr19QjH-LI";
export const KEY_NOTIFICATION_FIREBASE =
  "BLyyYZvL_t798ckAr2FP1D7hW8mzHAP3hmsRqASBwBhFu3D2U4nzpGy8VRtQcOOgbsvZO0PSuSjcnW24ry9OuOo";

export const DESTINOS = [
  { "id": 1, "value": "Vivienda Unifamiliar"},
  { "id": 2, "value": "Comercio"},
  { "id": 3, "value": "Oficina"},
  { "id": 4, "value": "Industria"},
  { "id": 5, "value": "Depósito"},
  { "id": 6, "value": "Vivienda Multifamiliar"},
  { "id": 7, "value": "Taller"},
  { "id": 8, "value": "Salud"},
  { "id": 9, "value": "Otros"}
]

export const ACCESOS = {
  ABM_VISUALIZAR: "ABMVIS",
  ABM_USUARIOS: "ABMUSU",
  ABM_TIPOS_TRAMITE: "ABMTITRA",
  ABM_REQUISITOS: "ABMREQ",
  ABM_OFICINAS: "ABMOFI",
  TRAMITE_ALTA : "TRALT",
  TRAMITE_MODIFICACION: "TRMOD",
  TRAMITE_EDITAR_FINALIZADO:"TREDIFI",
  TRAMITE_COMPARTIR: "TRMCOMP",
  TRAMITE_ELIMINAR: "TRMELI",
  TRAMITE_VER_DETALLE: "TRMDETA",
  TRAMITE_FINALIZAR: "FINTRA",
  TRAMITE_REABRIR: "TRAREAB",
  TRAMITE_DESCARGAR: "TRAARCH",
  TRAMITE_VER_TODOS: "TRVERT",
  REQUERIMIENTO_AGREGAR: "REQMAN",
  REQUERIMIENTO_ELIMINAR: "REQDEL",
  REQUERIMIENTO_VALIDAR: "REQVAL",
  REQUERIMIENTO_RESOLVER: "REQRES",
  REQUERIMIENTO_RECHAZAR: "REQREJ",
  REQUERIMIENTO_OPCIONAL: "REQOPC",
  REQUERIMIENTO_HISTORIAL: "REQHIS",
  REQUERIMIENTO_PLANTILLA: "REQPLAN",
  SEGUIMIENTO_MOVER: "SEGMOV",
  SMS_CREAR: "SMSCRE",
  SMS_RESPONDER: "SMSRESP",
  USUARIO_ALTA: "USUALT",
  USUARIO_HOMOLOGAR: "USUHOM",
  USUARIO_ACCESOS: "USUACC"

}


export const TIPO_DOCUMENTO = {
  MATRICULA: 0,
  DNI_FRENTE: 1,
  DNI_REVERSO: 2,
  PLANO: 3,
  ESCRITURA: 4
}

export const TIPO_DOCUMENTO_NOMBRE = {
  0: "MATRICULA",
  1: "DNI FRENTE",
  2: "DNI REVERSO",
  3: "PLANO",
  4: "ESCRITURA",
}

export const TIPO_RESPUESTA = [
  { "id": 1, "value": "Archivo"},
  { "id": 2, "value": "Observación"},
  { "id": 3, "value": "Si/No"},
  { "id": 4, "value": "Si/No/No Aplica"},
]